/* eslint-disable max-len */

export const text = [`В павильоне открыта постоянная экспозиция, связанная с историей оружия.`, `В Албанской комнате с помощью 3D–технологий воссоздана соответствующая акварель Алоизия Рокштуля. В одной из башен демонстрируется фильм об истории «каруселей», а в комнате с винтовой лестницей можно изучить электронные книги по истории Арсенала и узнать о хранителях императорских библиотеки и коллекции оружия.`]
;
